import {
  MAXIMAP_RADIUS,
  maximapBackdrop,
  minimapPanelBackground,
  minimapPanelBorder,
  minimapPanelShadow,
} from '@blocksuite/affine-shared/styles';
import { streamLainMotionTiming } from '@blocksuite/affine-shared/utils';
import { css, unsafeCSS } from 'lit';

const morphTiming = streamLainMotionTiming('morph');

export const maximapStyles = css`
  :host {
    position: relative;
  }
  /* The overview's map keeps its full size from the first step; its container grows around it. */
  :host([expanded]) {
    color: var(--streamlain-v2-text-secondary, #888);
    position: absolute;
    left: 0;
    top: 0;
    width: var(--maximap-size);
    height: var(--maximap-size);
    min-height: 0;
    max-height: none;
    border: 0;
    border-radius: 0;
    background: transparent;
    box-shadow: none;
  }
  canvas {
    touch-action: none;
  }
  .map-control {
    position: absolute;
    z-index: 1;
    top: 8px;
    right: 8px;
    width: 32px;
    height: 32px;
    display: grid;
    place-items: center;
    padding: 0;
    border: 0;
    border-radius: 50%;
    color: var(--streamlain-v2-icon-primary);
    background: var(--streamlain-v2-layer-background-primary);
    box-shadow: 0 2px 8px #0003;
    cursor: pointer;
  }
  .map-control svg {
    width: 18px;
    height: 18px;
  }
  .map-control:hover {
    color: var(--streamlain-v2-brand-primary);
  }
  .map-control:focus-visible,
  canvas:focus-visible {
    outline: 2px solid var(--streamlain-v2-brand-primary);
    outline-offset: -2px;
  }
  .maximap-dialog {
    position: fixed;
    inset: auto;
    margin: 0;
    padding: 0;
    border: 0;
    border-radius: 0;
    background: transparent;
    box-shadow: none;
    overflow: hidden;
    max-width: none;
    max-height: none;
  }
  .maximap-dialog[open] {
    display: grid;
    place-items: center;
  }
  /* The overview's place at full size. */
  .maximap-surface {
    position: relative;
    width: var(--maximap-size);
    height: var(--maximap-size);
  }
  /* The overview's container: the small map's panel, grown. It fills its place at rest. */
  .maximap-frame {
    position: absolute;
    inset: 0;
    overflow: hidden;
    border-radius: ${MAXIMAP_RADIUS}px;
    background: ${unsafeCSS(minimapPanelBackground)};
    box-shadow: ${unsafeCSS(minimapPanelShadow)};
  }
  .maximap-frame::after {
    content: '';
    position: absolute;
    inset: 0;
    border: ${unsafeCSS(minimapPanelBorder)};
    border-radius: inherit;
    pointer-events: none;
  }
  .maximap-dialog::backdrop {
    background: ${unsafeCSS(maximapBackdrop)};
  }
  .maximap-dialog .map-control {
    top: 12px;
    right: 12px;
    width: 36px;
    height: 36px;
    opacity: var(--maximap-detail, 1);
  }
  /* The small map is the maximap while that is open: it grows out of it and back into it. */
  :host([data-maximap-open]) {
    visibility: hidden;
  }
  :host([data-maximap-open]) .maximap-dialog {
    visibility: visible;
  }
  .maximap-dialog[data-closing] .maximap-surface {
    pointer-events: none;
  }
  @media (prefers-reduced-motion: no-preference) {
    .maximap-dialog[open]::backdrop {
      animation: reveal-map-backdrop ${unsafeCSS(morphTiming)};
    }
    .maximap-dialog[data-closing]::backdrop {
      animation: dismiss-map-backdrop ${unsafeCSS(morphTiming)};
    }
    @keyframes reveal-map-backdrop {
      from {
        opacity: 0;
      }
      to {
        opacity: 1;
      }
    }
    @keyframes dismiss-map-backdrop {
      from {
        opacity: 1;
      }
      to {
        opacity: 0;
      }
    }
  }
`;
